import { render } from "./CaseForm.vue?vue&type=template&id=66662234&scoped=true"
import script from "./CaseForm.vue?vue&type=script&lang=ts"
export * from "./CaseForm.vue?vue&type=script&lang=ts"

import "./CaseForm.vue?vue&type=style&index=0&id=66662234&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66662234"

export default script